<script>
  export let variant = 'primary'; // primary, secondary, success, ghost
  export let size = 'md'; // sm, md, lg
  export let disabled = false;
  export let fullWidth = false;
  export let type = 'button';
</script>

<button
  {type}
  {disabled}
  class="btn btn-{variant} btn-{size} {fullWidth ? 'btn-full' : ''}"
  on:click
>
  <slot />
</button>

<style>
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-family: var(--font-body);
    font-weight: 600;
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
    transition: all var(--dur-med) var(--ease-out);
    text-decoration: none;
  }

  .btn-primary {
    background: var(--accent);
    color: var(--paper-0);
    box-shadow: var(--shadow-sm);
  }

  .btn-primary:hover:not(:disabled) {
    background: var(--accent-hover);
    box-shadow: var(--shadow-md);
    transform: translateY(-1px);
  }

  .btn-secondary {
    background: var(--bg-sunken);
    color: var(--fg);
    border: 1px solid var(--border);
  }

  .btn-secondary:hover:not(:disabled) {
    background: var(--teal-50);
    border-color: var(--teal-500);
  }

  .btn-success {
    background: var(--success);
    color: var(--paper-0);
    box-shadow: var(--shadow-sm);
  }

  .btn-success:hover:not(:disabled) {
    background: var(--fern-500);
    box-shadow: var(--shadow-md);
    transform: translateY(-1px);
  }

  .btn-ghost {
    background: transparent;
    color: var(--fg);
    border: 1px solid var(--border);
  }

  .btn-ghost:hover:not(:disabled) {
    background: var(--bg-sunken);
    border-color: var(--accent);
  }

  .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .btn-sm {
    padding: 8px 16px;
    font-size: 0.875rem;
  }

  .btn-md {
    padding: 12px 24px;
    font-size: 0.9375rem;
  }

  .btn-lg {
    padding: 14px 32px;
    font-size: 1.125rem;
  }

  .btn-full {
    width: 100%;
  }
</style>
